<template>
    <div class="modify-tower">
    <a-row class="mobile-top">
        <a-button type="link" @click="showDrawer">
            {{ $route.params.id ? towerInfo.title : "选择塔" }}
        </a-button>
        <a-drawer
            placement="left"
            :closable="false" :visible="visible"
            @close="onClose" class="tower-drawer"
        >
            <tower-menu ref="menu" :towers="towers" @selectTower="selectTower"></tower-menu>
        </a-drawer>
    </a-row>
    <a-row type="flex" :gutter="16" class="container">
        <a-col flex="180px" class="listContainer left-menu">
            <tower-menu ref="menu" :towers="towers" @selectTower="selectTower"></tower-menu>
        </a-col>
        <a-col flex="auto">
            <div class="infoTable" v-if="$route.params.id">
                <a-divider orientation="left">基本信息</a-divider>
                <a-descriptions size="small"
                    :column="{ xxl: 3, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }"
                >
                    <a-descriptions-item label="name">
                        <a :href="towerInfo.link" target="_blank"> {{ towerInfo.name }} </a>
                    </a-descriptions-item>
                    <a-descriptions-item label="层数">
                        {{ towerInfo.floors }}
                    </a-descriptions-item>
                    <a-descriptions-item label="发布时间">
                        {{ towerInfo.uploadtime }}
                    </a-descriptions-item>
                    <a-descriptions-item label="更新时间">
                        {{ format(towerInfo.createtime) }}
                    </a-descriptions-item>
                </a-descriptions>
                <a-divider orientation="left">修改信息</a-divider>
                <a-form-model :model="form" :rules="rules" ref="loginForm"
                    :labelCol="{ span: 5 }" :wrapperCol="{ span: 15 }"
                    class="smallForm"
                >
                    <a-form-model-item label="标题">
                        <a-input v-model="form.title"></a-input>
                    </a-form-model-item>
                    <a-form-model-item label="颜色">
                        <a-radio-group v-model="form.color">
                            <a-radio-button 
                                v-for="(color, index) of colors" :key="index"
                                :value="index.toString()" :style="{ background: color.value }"
                            >
                                {{ color.name }}
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item label="标签" :wrapperCol="{ span: 18 }">
                        <a-checkbox-group :options="tags" v-model="tagProxy" />
                    </a-form-model-item>
                    <a-form-model-item label="作者的话" :wrapperCol="{ span: 18 }">
                        <a-textarea placeholder="显示在底部的话" v-model="form.text" :rows="3" />
                    </a-form-model-item>
                    <a-row type="flex" justify="end" :gutter="16">
                        <a-col>
                            <a-button @click="resetForm" :disabled="!diff">重置</a-button>
                        </a-col>
                        <a-col>
                            <a-button type="primary" @click="submitForm" :disabled="!diff">修改</a-button>
                        </a-col>
                        <a-col :span="2"></a-col>
                    </a-row>
                </a-form-model>
                <a-divider orientation="left">危险操作</a-divider>
                <a-row type="flex">
                    <a-col :span="10">
                        <a-button @click="callclearboard">清榜</a-button>
                    </a-col>
                    <a-col flex="auto">
                        <a-button type="danger" @click="withdraw">下架</a-button>
                    </a-col>
                </a-row>
            </div>
            <a-empty v-else :description="false" />
        </a-col>
    </a-row>
    <a-modal
        :title="`清榜 - ${ towerInfo.title }`"
        :visible="clearVisible" :width="'85%'"
        :confirm-loading="clearing"
        @ok="clearboard()"
        @cancel="cancel"
    >
        难度: <a-select v-model="clearForm.hard" :style="{ minWidth: '120px' }">
            <a-select-option v-for="hard of hardList" :key="hard.value"
                :value="hard.value">{{ hard.label }}</a-select-option>
        </a-select>
        结局: <a-select v-model="clearForm.ending" :style="{ minWidth: '120px' }">
            <a-select-option v-for="ending of endingList" :key="ending.value"
                :value="ending.value">{{ ending.label }}</a-select-option>
        </a-select>
        <br/><br/>
        分数 > <a-input :style="{ width: '180px' }" v-model="clearForm.score"></a-input>
        仅清理未通过录像: <a-checkbox v-model="clearForm.onlyInvaild"></a-checkbox>
    </a-modal>
    </div>
</template>

<script>
import TowerMenu from './TowerMenu.vue'
import { clone, createFormData } from '../../../utils/utils.js'
import axios from "../../../plugins/axios.js"
import { TAGS, COLORS } from '../../../constant.js'

let towerListMemo = null, idMemo = null;
const towerMemo = {};
const infos = {
    name: "",
    createtime: 0,
    updatetime: 0,
    tag: "",
};
export default {
    data: () => ({
        towers: [],
        towerInfo: {},
        form: infos,
        rules: infos,
        tags: TAGS,
        colors: COLORS,
        diff: false,
        visible: false,
        clearVisible: false,
        clearing: false,
        clearForm: {
            hard: '',
            ending: '',
            onlyInvaild: false
        }
    }),
    computed: {
        tagProxy: {
            get() {
                return this.form.tag.split('|');
            },
            set(value) {
                this.form.tag = value.join('|');
            }
        },
        hardList() {
            const options = [{ label: '全部', value: '' }];
            if (this.towerInfo.hard?.length > 1) {
                options.push(...this.towerInfo.hard.map((e) => ({ label: e, value: e })));
            }
            return options;
        },
        endingList() {
            const options = [{ label: '全部', value: '' }];
            if (this.towerInfo.ending?.length > 1) {
                options.push(...this.towerInfo.ending.map((e) => ({ label: e, value: e })));
            }
            return options;
        }
    },
    async created() {
        if (!towerListMemo) {
            const { data } = await axios.get(`/backend/admin/tower/list.php`);
            towerListMemo = data.reverse();
        }
        this.towers = towerListMemo;
        if (this.$route.params.id) {
            this.loadTower(this.$route.params.id);
        }
    },
    beforeRouteEnter(to, from, next) {
        if (!to.params.id && idMemo) {
            next(vm => vm.selectTower(idMemo));
        } else {
            next();
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (to.params.id) {
            this.loadTower(to.params.id)
                .then(() => next());
        } else {
            next();
        }
    },
    methods: {
        selectTower(key) {
            this.$router.push({ name: 'modifyTower', params: { id: key } });
        },
        async loadTower(id, force = false) {
            if (!towerMemo[id] || force) {
                const { data } = await axios.get(`/backend/admin/tower/info.php?name=${id}`);
                towerMemo[id] = data.info;
            }
            this.towerInfo = towerMemo[id];
            this.form = clone(towerMemo[id]);
            this.showIndex(this.towers.findIndex(e => e.name == id));
            idMemo = id;
        },
        showIndex(index) {
            this.$refs.menu.showIndex(index);
        },
        resetForm() {
            this.form = clone(this.towerInfo);
        },
        async submitForm() {
            const modification = {};
            for (let key in this.form) {
                if (Array.isArray(this.form[key])) continue;
                if (this.form[key] != this.towerInfo[key]) {
                    modification[key] = this.form[key];
                }
            }
            this.loading = true;
            const { data } = await axios.post("/backend/admin/tower/modify.php", createFormData({
                modification: JSON.stringify(modification), name: this.$route.params.id
            }));
            this.loading = false;
            if (data.code == 0) {
                this.$message.success("修改成功");
                const newData = clone(this.form);
                towerMemo[this.$route.params.id] = newData;
                this.towerInfo = newData;
                this.diff = false;
            } else {
                this.$message.error("修改失败");
            }
        },
        callclearboard() {
            this.clearVisible = true;  
        },
        clearboard() {
            const name = this.$route.params.id;
            this.clearing = true;
            axios.post("/backend/admin/tower/clearBoard.php", createFormData({ name, ...this.clearForm }))
                .then(({ data }) => {
                    this.clearing = false;
                    if (data.code == 0) {
                        this.clearVisible = false;
                        this.$message.success("清榜成功");
                    } else {
                        this.$message.error("操作失败");
                    }
                });
        },
        cancel() {
            this.clearVisible = false;
        },
        withdraw() {
            const name = this.$route.params.id;
            this.$confirm({
                title: '下架确认',
                content: `确定要下架 ${ this.towerInfo.title } 吗, 操作后将无法撤回`,
                okText: '确认',
                cancelText: '取消',
                onOk: async () => {
                    axios.post("/backend/admin/tower/withdraw.php", createFormData({ name }))
                        .then(({ data }) => {
                            if (data.code == 0) {
                                towerListMemo = towerListMemo.filter(e => e.name != name);
                                this.towers = towerListMemo;
                                this.$router.push({ name: 'modifyTower' });
                                this.$message.success("下架成功");
                            } else {
                                this.$message.error("操作失败");
                            }
                        })
                }
            });
        },
        format(timestr) {
            return new Date(Number(timestr) * 1000).toLocaleString()
        },
        showDrawer() {
            this.visible = true;
        },
        onClose() {
            this.visible = false;
        },
    },
    watch: {
        form: {
            handler(data) {
                for (let key in data) {
                    if (Array.isArray(data[key])) continue;
                    if (data[key] != this.towerInfo[key]) {
                        this.diff = true;
                        return;
                    }
                }
                this.diff = false;
            },
            deep: true
        }
    },
    components: {
        TowerMenu
    }
}
</script>

<style lang="less">
.smallForm .ant-form-item {
    margin-bottom: 8px;
}
.tower-drawer {
    .ant-drawer-body {
        height: 100%;
    }
}
</style>

<style lang="less" scoped>
.modify-tower {
    height: 100%;
}
.container {
    height: 100%;
    flex-wrap: nowrap;
}
.listContainer {
    height: 100%;
}
.infoTable {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
}
@media screen and (min-width: 600px) {
    .mobile-top {
        display: none;
    }
}
@media screen and (max-width: 600px) {
    .left-menu {
        display: none;
    }
}
</style>